<button mat-icon-button color="primary" matTooltip="{{'COMMON_LIST.ACTIONS.VIEW' | translate}}"
    matTooltipPosition="above" (click)="actionClick('view')">
    <mat-icon class="mx-8">visibility</mat-icon>
</button>

<!-- <button mat-icon-button color="primary" matTooltip="{{'ALERTS.EDIT' | translate}}"
    matTooltipPosition="above" (click)="actionClick('edit')" *ngIf="statusId == 4">
    <mat-icon class="mx-8">arrow_forward</mat-icon>
</button>-->

<button mat-icon-button color="primary" matTooltip="{{'COMMON_LIST.ACTIONS.ACTIONS' | translate}}"
    matTooltipPosition="above" (click)="actionClick('followUpTask')" *ngIf="statusId == 4 && followUpTaskButton">
    <mat-icon class="mx-8">fact_check</mat-icon>
</button> 
<button mat-icon-button color="primary" matTooltip="{{'COMMON_LIST.ACTIONS.COMPLETE' | translate}}"
    matTooltipPosition="above" (click)="actionClick('completeItem')" *ngIf="statusId == 1">
    <mat-icon class="mx-8">check</mat-icon>
</button>

<button mat-icon-button color="primary" matTooltip="{{'COMMON_LIST.ACTIONS.RE-OPEN' | translate}}"
    matTooltipPosition="above" (click)="actionClick('reOpen')"  *ngIf="(statusId == 2 || statusId == 3 || statusId == 4) && !disableReOpenCase">
    <mat-icon class="mx-8">lock_open</mat-icon>
</button>

<button mat-icon-button color="primary" matTooltip="{{'COMMON_LIST.ACTIONS.DELETE' | translate}}"
    matTooltipPosition="above" (click)="actionClick('deleteItem')" *ngIf="deleteButton">
    <mat-icon class="mx-8">delete_outline</mat-icon>
</button>

